<template>
    <v-layout row wrap justify-end align-center>
        <v-flex v-if="show_search" xs12 md2>
            <v-text-field
                v-model="search_value"
                @input="$emit('update:search', search_value)"
                prepend-icon="search"
                label="Tìm kiếm"
                hide-details
            ></v-text-field>
        </v-flex>
        <v-flex v-if="show_building" xs12 md2>
            <v-select
                label="Tòa nhà"
                :disabled="loading"
                v-model="building_value"
                @change="$emit('update:chosen_building', building_value)"
                :items="list_building"
                prepend-icon="domain"
                required
                hide-details
            ></v-select>
        </v-flex>
        <v-flex v-if="show_agent" xs12 md2>
            <v-select
                label="Người dẫn phòng"
                :disabled="loading"
                v-model="agent_id_value"
                @change="$emit('update:agent_id', agent_id_value)"
                :items="bvs"
                prepend-icon="person_pin"
                item-text="name"
                item-value="user_id"
                required
                hide-details
            ></v-select>
        </v-flex>
        <v-flex v-if="show_date_start" xs12 md2>
            <v-menu
                :close-on-content-click="false"
                v-model="menu_date_start"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
                <v-text-field
                    slot="activator"
                    v-model="date_start_value"
                    label="Ngày bắt đầu"
                    :disabled="loading"
                    prepend-icon="event"
                    readonly
                    hide-details
                    clearable
                    @click:clear="$emit('update:date_start', '')"
                ></v-text-field>
                <v-date-picker
                    :disabled="loading"
                    locale="vi-VI"
                    v-model="date_start_value"
                    scrollable
                    @input="$emit('update:date_start', date_start_value); menu_date_start = false">
                </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex v-if="show_date_end" xs12 md2>
            <v-menu
                :close-on-content-click="false"
                v-model="menu_date_end"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
                <v-text-field
                    slot="activator"
                    v-model="date_end_value"
                    label="Ngày kết thúc"
                    :disabled="loading"
                    prepend-icon="event"
                    readonly
                    hide-details
                    clearable
                    @click:clear="$emit('update:date_end', '')"
                ></v-text-field>
                <v-date-picker
                    :disabled="loading"
                    locale="vi-VI"
                    v-model="date_end_value"
                    scrollable
                    @input="$emit('update:date_end', date_end_value); menu_date_end = false">
                </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex xs12 md2 v-if="show_month">
            <v-menu
                :close-on-content-click="false"
                v-model="menu_month_picker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :disabled="loading"
            >
                <v-text-field
                    slot="activator"
                    v-model="chosen_month_value"
                    label="Chọn tháng"
                    prepend-icon="event"
                    :loading="loading"
                    readonly
                    :disabled="loading"
                    hide-details
                ></v-text-field>
                <v-date-picker
                    min="2019-10"
                    locale="vi-VI"
                    type="month"
                    :disabled="loading"
                    v-model="chosen_month_value"
                    @input="$emit('update:chosen_month', chosen_month_value); menu_month_picker = false">
                </v-date-picker>
            </v-menu>
        </v-flex>
        <slot/>
    </v-layout>
</template>

<script>

import moment from 'moment'
import { list_building } from 'Constants/db-config'

export default {
    name: "page-tool-bar",
    props: {
        loading: Boolean,
        show_search: { type: Boolean, default: false },
        show_date_start: { type: Boolean, default: false },
        show_date_end: { type: Boolean, default: false },
        show_building: { type: Boolean, default: false },
        show_month: { type: Boolean, default: false },
        show_agent: { type: Boolean, default: false },
        search: String,
        date_start: String,
        date_end: String,
        chosen_building: String,
        chosen_month: String,
        agent_id: Number,
    },
    data(){
        return {
            menu_date_start: false,
            menu_date_end: false,
            menu_month_picker: false,
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            building_value: 'BN',
            search_value: '',
            date_start_value: moment().startOf('month').format('YYYY-MM-DD'),
            date_end_value: new Date().toISOString().substring(0, 10),
            chosen_month_value: new Date().toISOString().substring(0, 7)
        }
    },
    computed: {
        bvs(){
            return [...this.$store.state.app.bvs, { name: "Tất cả", user_id: null}]
        },
    },
    watch: {
        search(nv){
            this.search_value = nv
        },
        chosen_building: {
            handler: function (nv){
                this.building_value = nv
            },
            immediate: true
        },
        date_start: {
            handler: function (nv){
                this.date_start_value = nv
            },
            immediate: true
        },
        date_end: {
            handler: function (nv){
                this.date_end_value = nv
            },
            immediate: true
        },
        chosen_month: {
            handler: function (nv){
                this.chosen_month_value = nv
            },
            immediate: true
        },
        agent_id: {
            handler: function (nv){
                this.agent_id_value = nv
            },
            immediate: true
        }
    }
};
</script>

<style>
</style>